/**
 * CandidateCard component - displays individual candidate in carousel
 * Futuristic Clean Design: no shadows, no borders
 */
import styles from './CandidateCard.module.css';
import type { CandidateListItem } from '@/types/elections';

interface CandidateCardProps {
    candidate: CandidateListItem;
    onClick?: (candidate: CandidateListItem) => void;
    isSelected?: boolean;
}

export function CandidateCard({ candidate, onClick, isSelected }: CandidateCardProps) {
    const handleClick = () => {
        onClick?.(candidate);
    };

    return (
        <div
            className={`${styles.card} ${isSelected ? styles.selected : ''}`}
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleClick()}
        >
            <div className={styles.photoWrapper}>
                {candidate.photo_url ? (
                    <img
                        src={candidate.photo_url}
                        alt={candidate.full_name}
                        className={styles.photo}
                        loading="lazy"
                    />
                ) : (
                    <div className={styles.photoPlaceholder}>
                        {candidate.full_name.charAt(0)}
                    </div>
                )}
            </div>
            <div className={styles.info}>
                <h3 className={styles.name}>{candidate.full_name}</h3>
                <p className={styles.party}>{candidate.party}</p>
            </div>
        </div>
    );
}
